var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",on:{"click":_vm.subscribe}},[_vm._v("สมัครรับการแจ้งเตือน")])
}
var staticRenderFns = []

export { render, staticRenderFns }